import { forceLazyLoad } from '../global/helpers';
import { els } from './variables';

const tabs = {
	init() {
		this.setActiveTab();
		this.forceLazyLoad();
		this.updateTopOffset();

		this.updateTopOffset = this.updateTopOffset.bind(this);
		window.addEventListener('resize', this.updateTopOffset);
	},

	forceLazyLoad() {
		const tabs = document.querySelectorAll('.wp-block-emagine-tabs .em-tab-title');
		tabs.forEach((tab) => {
			tab.addEventListener('click', (e) => {
				const target = e.target.closest('.em-tab-title');
				if (target) {
					const tabId = target.dataset.tab;
					const tab = document.querySelector(`.em-inner-tab-${tabId}`);
					if (tab) {
						forceLazyLoad(tab);
						const event = document.createEvent('HTMLEvents');
						event.initEvent('resize', true, false);
						document.dispatchEvent(event);
					}
				}
			});
		});
	},

	setActiveTab() {
		const tabsBlocks = document.querySelectorAll('.em-tabs-wrap');
		if (tabsBlocks.length) {
			const activeTabTitleClass = 'em-tab-title-active';
			const inactiveTabTitleClass = 'em-tab-title-inactive';
			tabsBlocks.forEach((tabsBlock) => {
				// Remove the current active-tab class.
				tabsBlock.classList.forEach((className) => {
					if (className.indexOf('em-active-tab-') !== -1) {
						tabsBlock.classList.remove(className);
					}
				});

				// Then add the active class for the first tab.
				tabsBlock.classList.add('em-active-tab-1');

				// Remove the active class from any tab title that isn't the first.
				const firstTabTitle = tabsBlock.querySelector('.em-title-item:first-child');
				if (!firstTabTitle.classList.contains(activeTabTitleClass)) {
					const activeTabTitle = tabsBlock.querySelector(`.${activeTabTitleClass}`);
					activeTabTitle.classList.remove(activeTabTitleClass);
					activeTabTitle.classList.add(inactiveTabTitleClass);

					firstTabTitle.classList.remove(inactiveTabTitleClass);
					firstTabTitle.classList.add(activeTabTitleClass);
				}

				// Force accordions on mobile.
				if (!tabsBlock.classList.contains('em-tabs-mobile-layout-accordion')) {
					tabsBlock.classList.remove('em-tabs-mobile-layout-inherit');
					tabsBlock.classList.remove('em-tabs-mobile-layout-tabs');
					tabsBlock.classList.remove('em-tabs-mobile-layout-vtabs');
					tabsBlock.classList.add('em-tabs-mobile-layout-accordion');
					// Add class to causes accordion markup to be added.
					tabsBlock.classList.add('em-create-accordion');
				}

				tabsBlock.classList.add('loaded');
			});
		}
	},

	updateTopOffset() {
		const tabsTitleLists = document.querySelectorAll('.em-tabs-title-list');
		if (tabsTitleLists.length) {
			tabsTitleLists.forEach((tabsTitleList) => {
				tabsTitleList.style.top = els.header.classList.contains('has-notice') ? `${els.header.offsetHeight}px` : `${els.headerInner.offsetHeight}px`;
			});
		}
	},
};

tabs.init();
